import type { FilterState } from '@/entities/discovery';

export const domainKeys = {
  all: ['domain'] as const,
  domainTree: [...(['domain'] as const), 'domainTree'] as const,
  hierarchyPrefix: () => [...domainKeys.all, 'hierarchy'] as const,
  hierarchy: (limit: number) => [...domainKeys.hierarchyPrefix(), limit] as const,
  list: () => [...domainKeys.all, 'list'] as const,
  lists: (limit: number) => [...domainKeys.all, 'list', limit] as const,
  detail: (fqn: string) => [...domainKeys.all, 'detail', fqn] as const,
  subDomainsPrefix: () => [...domainKeys.all, 'subDomains'] as const,
  subDomains: (fqn: string) => [...domainKeys.all, 'subDomains', fqn] as const,
  assets: (fqn: string) => [...domainKeys.all, 'assets', fqn] as const,

  dataProductsPrefix: () => [...domainKeys.all, 'dataProducts'] as const,
  dataProducts: (fqn: string, filters: FilterState, query: string) =>
    [...domainKeys.dataProductsPrefix(), fqn, filters, query] as const,

  domainAssetsPrefix: () => [...domainKeys.all, 'domainAssets'] as const,
  domainAssets: (fqn: string) => [...domainKeys.domainAssetsPrefix(), fqn] as const,
} as const;
